import controller from './class-designer-link-editor.controller';
import template from './class-designer-link-editor.html';
import './class-designer-link-editor.scss';

export default {
	controller,
	template,
	bindings: {
		disabled: '<?ngDisabled',
		selected: '<ngModel',
	},
	require: {
		editor: '^^classDesignerEditor',
	},
};
